module.exports = __webpack_public_path__ + "img/sonacos.7b28cda8.jpg";